"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaddedOrderNumber = void 0;

var _padStart2 = _interopRequireDefault(require("lodash/padStart"));

var _toString2 = _interopRequireDefault(require("lodash/toString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var getPaddedOrderNumber = function getPaddedOrderNumber(orderNumber) {
  return (0, _padStart2["default"])((0, _toString2["default"])(orderNumber), 3, '0');
};

exports.getPaddedOrderNumber = getPaddedOrderNumber;